function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var t,
    e = require("stimulus"),
    s = (t = require("lodash.debounce")) && "object" == _typeof(t) && "default" in t ? t.default : t,
    n = function (t) {
  function e() {
    for (var e = [], s = arguments.length; s--;) {
      e[s] = arguments[s];
    }

    t.apply(this, e), this.extractTextValue = function (t) {
      return t.hasAttribute("data-autocomplete-label") ? t.getAttribute("data-autocomplete-label") : t.textContent.trim();
    };
  }

  return t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e, e.prototype.connect = function () {
    this.resultsTarget.hidden = !0, this.inputTarget.setAttribute("autocomplete", "off"), this.inputTarget.setAttribute("spellcheck", "false"), this.mouseDown = !1, this.onInputChange = s(this.onInputChange.bind(this), 300), this.onResultsClick = this.onResultsClick.bind(this), this.onResultsMouseDown = this.onResultsMouseDown.bind(this), this.onInputBlur = this.onInputBlur.bind(this), this.onKeydown = this.onKeydown.bind(this), this.inputTarget.addEventListener("keydown", this.onKeydown), this.inputTarget.addEventListener("blur", this.onInputBlur), this.inputTarget.addEventListener("input", this.onInputChange), this.resultsTarget.addEventListener("mousedown", this.onResultsMouseDown), this.resultsTarget.addEventListener("click", this.onResultsClick), "string" == typeof this.inputTarget.getAttribute("autofocus") && this.inputTarget.focus();
  }, e.prototype.disconnect = function () {
    this.hasInputTarget && (this.inputTarget.removeEventListener("keydown", this.onKeydown), this.inputTarget.removeEventListener("focus", this.onInputFocus), this.inputTarget.removeEventListener("blur", this.onInputBlur), this.inputTarget.removeEventListener("input", this.onInputChange)), this.hasResultsTarget && (this.resultsTarget.removeEventListener("mousedown", this.onResultsMouseDown), this.resultsTarget.removeEventListener("click", this.onResultsClick));
  }, e.prototype.sibling = function (t) {
    var e = Array.from(this.resultsTarget.querySelectorAll('[role="option"]:not([aria-disabled])')),
        s = this.resultsTarget.querySelector('[aria-selected="true"]'),
        n = e.indexOf(s),
        i = t ? e[n + 1] : e[n - 1];
    return i || (t ? e[0] : e[e.length - 1]);
  }, e.prototype.select = function (t) {
    for (var e = 0, s = this.resultsTarget.querySelectorAll('[aria-selected="true"]'); e < s.length; e += 1) {
      var n = s[e];
      n.removeAttribute("aria-selected"), n.classList.remove("active");
    }

    t.setAttribute("aria-selected", "true"), t.classList.add("active"), this.inputTarget.setAttribute("aria-activedescendant", t.id), this.scrollTo(this.resultsTarget, t);
  }, e.prototype.scrollTo = function (t, e) {
    var s = e.offsetTop - t.offsetTop,
        n = t.scrollTop,
        i = s + e.offsetHeight,
        r = n + t.offsetHeight;
    i > r ? t.scrollTop = n + i - r : s < n && (t.scrollTop = s);
  }, e.prototype.onKeydown = function (t) {
    switch (t.key) {
      case "Escape":
        this.resultsTarget.hidden || (this.hideAndRemoveOptions(), t.stopPropagation(), t.preventDefault());
        break;

      case "ArrowDown":
        var e = this.sibling(!0);
        e && this.select(e), t.preventDefault();
        break;

      case "ArrowUp":
        var s = this.sibling(!1);
        s && this.select(s), t.preventDefault();
        break;

      case "Tab":
        var n = this.resultsTarget.querySelector('[aria-selected="true"]');
        n && this.commit(n);
        break;

      case "Enter":
        var i = this.resultsTarget.querySelector('[aria-selected="true"]');
        i && !this.resultsTarget.hidden && (this.commit(i), this.hasSubmitOnEnterValue || t.preventDefault());
    }
  }, e.prototype.onInputBlur = function () {
    this.mouseDown || (this.resultsTarget.hidden = !0);
  }, e.prototype.commit = function (t) {
    if ("true" !== t.getAttribute("aria-disabled")) {
      if (t instanceof HTMLAnchorElement) return t.click(), void (this.resultsTarget.hidden = !0);
      var e = this.extractTextValue(t),
          s = t.getAttribute("data-autocomplete-value") || e;
      this.inputTarget.value = e, this.hasHiddenTarget ? (this.hiddenTarget.value = s, this.hiddenTarget.dispatchEvent(new Event("input")), this.hiddenTarget.dispatchEvent(new Event("change"))) : this.inputTarget.value = s, this.inputTarget.focus(), this.hideAndRemoveOptions(), this.element.dispatchEvent(new CustomEvent("autocomplete.change", {
        bubbles: !0,
        detail: {
          value: s,
          textValue: e
        }
      }));
    }
  }, e.prototype.onResultsClick = function (t) {
    if (t.target instanceof Element) {
      var e = t.target.closest('[role="option"]');
      e && this.commit(e);
    }
  }, e.prototype.onResultsMouseDown = function () {
    var t = this;
    this.mouseDown = !0, this.resultsTarget.addEventListener("mouseup", function () {
      return t.mouseDown = !1;
    }, {
      once: !0
    });
  }, e.prototype.onInputChange = function () {
    this.element.removeAttribute("value"), this.fetchResults();
  }, e.prototype.identifyOptions = function () {
    for (var t = 0, e = 0, s = this.resultsTarget.querySelectorAll('[role="option"]:not([id])'); e < s.length; e += 1) {
      s[e].id = this.resultsTarget.id + "-option-" + t++;
    }
  }, e.prototype.hideAndRemoveOptions = function () {
    this.resultsTarget.hidden = !0, this.resultsTarget.innerHTML = null;
  }, e.prototype.fetchResults = function () {
    var t = this,
        e = this.inputTarget.value.trim();
    if (!e || e.length < this.minLengthValue) this.hideAndRemoveOptions();else if (this.hasUrlValue) {
      var s = new URL(this.urlValue, window.location.href),
          n = new URLSearchParams(s.search.slice(1));
      n.append("q", e), s.search = n.toString(), this.element.dispatchEvent(new CustomEvent("loadstart")), fetch(s.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (t) {
        return t.text();
      }).then(function (e) {
        t.resultsTarget.innerHTML = e, t.identifyOptions();
        var s = !!t.resultsTarget.querySelector('[role="option"]');
        t.resultsTarget.hidden = !s, t.element.dispatchEvent(new CustomEvent("load")), t.element.dispatchEvent(new CustomEvent("loadend"));
      }).catch(function () {
        t.element.dispatchEvent(new CustomEvent("error")), t.element.dispatchEvent(new CustomEvent("loadend"));
      });
    }
  }, e.prototype.open = function () {
    this.resultsTarget.hidden && (this.resultsTarget.hidden = !1, this.element.setAttribute("aria-expanded", "true"), this.element.dispatchEvent(new CustomEvent("toggle", {
      detail: {
        input: this.input,
        results: this.results
      }
    })));
  }, e.prototype.close = function () {
    this.resultsTarget.hidden || (this.resultsTarget.hidden = !0, this.inputTarget.removeAttribute("aria-activedescendant"), this.element.setAttribute("aria-expanded", "false"), this.element.dispatchEvent(new CustomEvent("toggle", {
      detail: {
        input: this.input,
        results: this.results
      }
    })));
  }, e;
}(e.Controller);

n.targets = ["input", "hidden", "results"], n.values = {
  submitOnEnter: Boolean,
  url: String,
  minLength: Number
}, exports.Autocomplete = n;